import React from 'react';
import './Team.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';


const Team = () => {

    const teams = [
        {
            'img': "https://www.freemedicalinfo.in/images/profile/1720001348-Dr-Bhagat-Tanwar-new-web-Image-1.webp",
            'name': 'Bhagat Tanwar'
        },
        {
           'img': "https://lh3.googleusercontent.com/p/AF1QipOdj71bwx2OvgXcvk5LsU4X2dSswh3pIzAe44FA=s1360-w1360-h1020-rw",
            'name': 'Poorna Tanwar'
            
        }
        // {
        //     'img': "https://www.freemedicalinfo.in/images/profile/1720001348-Dr-Bhagat-Tanwar-new-web-Image-1.webp",
        //     'name': 'Bhagat Tanwar'
        // },
        // {
        //    'img': "https://www.freemedicalinfo.in/images/profile/1720001348-Dr-Bhagat-Tanwar-new-web-Image-1.webp",
        //     'name': 'Bhagat Tanwar'
        // }
    ]


    return (
        <section className='team-section pt-100' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <SectionTitle 
                            subTitle="Meet our Team"
                            title="Get to know the dentalist
                            dental Team"
                        />
                    </div>

                    <div className="col-lg-5">
                        <p className='pt-5'>
                        Dr. Bhagat Tanwar and Dr. Poorna Tanwar lead a dedicated team, combining their expertise in Conservative Dentistry, Endodontics, and Orthodontics. With years of experience, they offer advanced treatments like root canals, smile design, and Invisalign, ensuring the best care for every patient.
                        </p>
                    </div>
                </div>

                <div className="row">
                    {
                        teams.map (team => 
                            <div className="col-lg-3 col-sm-6">
                                <div className="team-card">
                                    <div className="team-img">
                                        <img src={team.img} alt="" />
                                    </div>
                                    <h3>{team.name}</h3>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Team;